import { Select, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { components as ReactSelectComponents } from 'react-select';
import styled from 'styled-components';

import { ROLES } from './constants';

const OptionWrapper = styled.button`
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

function OptionComponent(opt) {
  return (
    <ReactSelectComponents.Option {...opt}>
      <OptionWrapper>
        <Typography variant="body1SemiBold">{opt.label}</Typography>
        <Typography variant="body1" emphasis="weaker">
          {opt.data.desc}
        </Typography>
      </OptionWrapper>
    </ReactSelectComponents.Option>
  );
}

function RoleSelect(props) {
  const { t } = useTranslation();

  return (
    <Select
      placeholder={t('selectRole')}
      options={ROLES}
      components={{
        Option: OptionComponent
      }}
      {...props}
      styles={{
        option: () => ({ height: '100%', whiteSpace: 'normal', alignItems: 'flex-start' }),
        ...props.styles
      }}
    />
  );
}

RoleSelect.propTypes = {
  styles: PropTypes.any
};

export { RoleSelect };
